import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/Pages/v001_login.vue'
import ItemList from '@/Pages/v002_itemList.vue'
import UserSetting from '@/Pages/v003_userSetting.vue'
import AuctionRegister from '@/Pages/v004_auctionRegister.vue'
import RegisterItem from '@/Pages/v005_registerItem.vue'
import CreateUser from '@/Pages/createUser.vue'
import Sell from '@/Pages/v006_sell.vue'
import ShipCsv from '@/Pages/v007_shipCsv.vue'
import Inquiry from '@/Pages/inquiry.vue'
import FixedPhrase from '@/Pages/v010_fixed_phrase.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/registerItem/:id/:pageNum',
    name: 'RegisterItem',
    component: RegisterItem,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/itemList/:pageNum',
    name: 'ItemList',
    component: ItemList,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/auctionRegister',
    name: 'AuctionRegister',
    component: AuctionRegister,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/userSetting',
    name: 'UserSetting',
    component: UserSetting,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/createUser',
    name: 'CreateUser',
    component: CreateUser,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/sell',
    name: 'Sell',
    component: Sell,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/trading',
    name: 'trading',
    component: ShipCsv,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/inquiry',
    name: 'Inquiry',
    component: Inquiry,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/fixedPhrase',
    name: 'fixedPhrase',
    component: FixedPhrase,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/*',
    name: 'Login',
    component: Login
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: '/TOOL',
  routes
})
router.beforeEach (async (to, from, next) => {
  let vm = Vue.prototype
  var auth = vm.$functions.isAuth()
  if (to.matched.some(record => record.meta.requiresAuth) && !auth) {
    next({ path: '/', query: { redirect: to.fullPath }});
  } else {
    next()
  }
});
export default router
